module.exports = __webpack_public_path__ + "static/media/profile.cae96f59.jpeg";